// src/pages/admin/Medicines.jsx
import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import CrudPage from '../../components/admin/CrudPage';
import { medicineAPI, configAPI } from '../../services/api';

const Form = ({ form, onChange, categories, subcategories, routes }) => {
  const filteredSubs = subcategories.filter(s => String(s.category_id) === String(form.category_id));
  return (
    <>
      <div className="form-group">
        <label className="form-label required">Medicine Name</label>
        <input className="form-input" name="name" value={form.name || ''} onChange={onChange} placeholder="e.g. Amoxicillin 250mg" required />
      </div>
      <div className="form-group">
        <label className="form-label">Generic Name</label>
        <input className="form-input" name="generic_name" value={form.generic_name || ''} onChange={onChange} placeholder="e.g. Amoxicillin Trihydrate" />
      </div>
      <div className="form-row">
        <div className="form-group">
          <label className="form-label required">Category</label>
          <select className="form-select" name="category_id" value={form.category_id || ''} onChange={onChange} required>
            <option value="">— Select —</option>
            {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Subcategory</label>
          <select className="form-select" name="subcategory_id" value={form.subcategory_id || ''} onChange={onChange} disabled={!form.category_id}>
            <option value="">— Select —</option>
            {filteredSubs.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
        </div>
      </div>
      <div className="form-group">
        <label className="form-label">Route of Administration</label>
        <select className="form-select" name="route_config_id" value={form.route_config_id || ''} onChange={onChange}>
          <option value="">— Select Route —</option>
          {routes.map(r => <option key={r.id} value={r.id}>{r.display_label}</option>)}
        </select>
      </div>
      <div className="form-group">
        <label className="form-label">Description</label>
        <textarea className="form-textarea" name="description" value={form.description || ''} onChange={onChange} />
      </div>
    </>
  );
};

export default function Medicines() {
  const [categories,    setCategories]    = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [routes,        setRoutes]        = useState([]);

  const [filterCategory, setFilterCategory] = useState('');
  const [filterSubcategory, setFilterSubcategory] = useState('');

  useEffect(() => {
    medicineAPI.getCategories().then(r => setCategories(r.data.data));
    medicineAPI.getSubcategories().then(r => setSubcategories(r.data.data));
    configAPI.getAll({ config_key: 'MD_CFG_ROUTE' }).then(r => setRoutes(r.data.data));
  }, []);

  const handleCategoryChange = (e) => {
    setFilterCategory(e.target.value);
    setFilterSubcategory('');
  };

  const filteredSubs = subcategories.filter(s => String(s.category_id) === String(filterCategory));

  return (
    <AdminLayout title="Medicines">
      <CrudPage
        title="Medicines"
        subtitle="Manage the medicine formulary"
        columns={[
          { key: 'id', label: 'ID' },
          { key: 'name', label: 'Medicine Name', render: r => <strong>{r.name}</strong> },
          { key: 'generic_name', label: 'Generic Name' },
          { key: 'category_name', label: 'Category' },
          { key: 'subcategory_name', label: 'Subcategory' },
          { key: 'route_label', label: 'Route' },
        ]}
        fetchFn={medicineAPI.getAll}
        createFn={medicineAPI.create}
        updateFn={medicineAPI.update}
        deleteFn={medicineAPI.delete}
        FormComponent={Form}
        formDefault={{ name: '', generic_name: '', category_id: '', subcategory_id: '', route_config_id: '', description: '' }}
        extraProps={{ categories, subcategories, routes }}
        renderFilters={() => (
          <div style={{ display: 'flex', gap: 8 }}>
            <select className="form-select" style={{ maxWidth: 200, margin: 0 }}
              value={filterCategory} onChange={handleCategoryChange}>
              <option value="">All Categories</option>
              {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
            <select className="form-select" style={{ maxWidth: 200, margin: 0 }}
              value={filterSubcategory} onChange={e => setFilterSubcategory(e.target.value)}>
              {!filterCategory ? <option value="">null</option> : <option value="">All Subcategories</option>}
              {filterCategory && filteredSubs.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
          </div>
        )}
        customFilter={row => {
          if (filterCategory && String(row.category_id) !== filterCategory) return false;
          if (filterSubcategory && String(row.subcategory_id) !== filterSubcategory) return false;
          return true;
        }}
      />
    </AdminLayout>
  );
}
